var map = {
	"./Group 22302.png": 1143,
	"./avatar-christmas.webp": 1144,
	"./bottom-bg-christmas.webp": 1145,
	"./btn-active.png": 1146,
	"./content-deco-1.webp": 1147,
	"./content-deco-2.webp": 1148,
	"./content-deco-3.webp": 1149,
	"./content-deco-4.webp": 1150,
	"./deco-3.webp": 1151,
	"./deposit-icon.webp": 1152,
	"./home-icon-active.webp": 1153,
	"./home-icon.webp": 1154,
	"./live-icon-active.webp": 1155,
	"./live-icon.webp": 1156,
	"./master-bg.jpg": 1157,
	"./me-icon-active.webp": 1158,
	"./me-icon.webp": 1159,
	"./platform.png": 1160,
	"./platform.webp": 1161,
	"./promos-icon-active.webp": 1162,
	"./promos-icon.webp": 1163,
	"./promos.webp": 1164,
	"./service-christmas.webp": 1165,
	"./snowman.webp": 1166,
	"./sponsor-icon-active.webp": 1167,
	"./sponsor-icon.webp": 1168,
	"./title-deco-left.webp": 1169,
	"./title-deco-right.webp": 1170,
	"./tree.webp": 1171,
	"./vip-icon.webp": 1172,
	"./vip.webp": 1173,
	"./withdraw-icon.webp": 1174,
	"./wwr-img.webp": 1175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;